import Vue from "vue";
export default Vue.extend({
    name: "Clear",
    mounted() {
        if (this.$route.query.pass !== "bqwyzvxa") {
            this.$router.push({ path: "/" });
        }
        document.title = this.$route.name || "すごろーく - クリア";
        this.$gtag.pageview({
            // eslint-disable-next-line @typescript-eslint/camelcase
            page_path: this.$route.path,
            // eslint-disable-next-line @typescript-eslint/camelcase
            page_title: this.$route.name || undefined
        });
    }
});
